import { useMemo } from 'react';
import { FormsBackPage } from '../store/senderBuild/types';

export function useNavigatedFromForms(): boolean {
  return useMemo(() => {
    // Method 1: Check document referrer (most immediate)
    const referrerFromForms = document.referrer.includes('forms.skyslope');

    // Method 2: Check URL parameters for valid Forms backPage values
    const params = new URLSearchParams(window.location.search);
    const backPageValue = params.get('backPage');
    const hasFormsParams =
      backPageValue !== null && Object.values(FormsBackPage).includes(backPageValue as FormsBackPage);

    return referrerFromForms || hasFormsParams;
  }, []);
}
